<template>
  <div>
    <section class="blog-area4">
        <div class="container">
            <div class="row">
                <div class="col-lg-12 col-sm-12">
                    <div class="blog-content-wrap">
                        <div class="blog-item">
                            <div class="blog-img-box">
                                <img  v-if="article.picsrc" :src="`${global.remoteIp}/uploads/${article.picsrc}`" :alt="article.title">
                                <!-- <span class="blog__date">{{article.addtime}}</span> -->
                            </div>
                            <div class="blog-content">
                                <h3 class="blog__title">{{article.title}}</h3>
                                <ul class="blog__list">
                                    <li><span class="la la-user"></span><a href="#">{{article.writer}}</a></li>
                                    <li><span class="la la-tags"></span>
                                        {{article.addtime}}
                                    </li>
                                    <li><span class="la la-eye"></span>{{article.artvisits}}</li>
                                </ul>
                                <p class="blog__desc"  v-html="article.contentHtml" ref="print">
                                </p>
                                <div class="tags-item">
                                    <ul class="tag__list" >
                                        <li><span>新闻来源：</span></li>
                                        <li v-if="article.source"><a :href="article.source">{{article.source}}</a></li>
                                    </ul>
                                    <ul class="social__links">
                                        <li @click="print()"><i class="el-icon-printer"></i><span>打印</span></li>
                                    </ul>
                                </div><!-- end tags-item -->
                            </div><!-- end blog-content -->
                        </div><!-- end blog-post-item -->
                    </div><!-- end blog-post-wrapper -->
                </div><!-- end col-md-12-->
            </div><!-- end row -->
        </div><!-- end container -->
    </section>
  </div>
</template>

<script>
import global from "@/components/PublicComs/Common.vue";
export default {
  data () {
    return {
         global,
      article: {},
    };
  },

  components: {},

  computed: {},

  mounted() {
    let plateId = this.$route.params.plateId;

    let articleId = this.$route.params.articleId;
    if(articleId == "000000")
    {
      this.$axios.get(`/api/categorys/${plateId}/articles`).then((res) => {
        if (res.data) {
          let  articles = res.data.data;
          if(articles.length==0) return;
          this.$axios.get(`/api/articles/${articles[0]._id}`).then((res) => {
            if (res.data) {
              this.article = res.data.data;
              if(!this.article.addtime)
              {
                let addtime = this.article.createdAt;
                let date = new Date(addtime);
                this.article.addtime=`${date.getFullYear()}-${("00"+(date.getMonth()+1)).slice(-2)}-${("00"+date.getDate()).slice(-2)} ${("00"+date.getHours()).slice(-2)}:${("00"+date.getMinutes()).slice(-2)}:${("00"+date.getSeconds()).slice(-2)}`
              }
            }
          });
        }
      });
    }else
    {
      this.$axios.get(`/api/articles/${articleId}`).then((res) => {
        if (res.data) {
          this.article = res.data.data;
          if(!this.article.addtime)
          {
            let addtime = this.article.createdAt;
            let date = new Date(addtime);
            this.article.addtime=`${date.getFullYear()}-${("00"+(date.getMonth()+1)).slice(-2)}-${("00"+date.getDate()).slice(-2)} ${("00"+date.getHours()).slice(-2)}:${("00"+date.getMinutes()).slice(-2)}:${("00"+date.getSeconds()).slice(-2)}`
          }
        }
      });
    }
  },

  methods: {
       print(){
        this.$print(this.$refs.print)
    }
  }
}

</script>
<style scoped>

/*-===============================
    BLOG AREA 4
===============================-*/
.blog-area4 {
  padding-top: 120px;
  padding-bottom: 120px;
}
.blog-area4 img {
  width: 100%;
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .blog-area4 {
    padding-bottom: 0;
  }
}

@media only screen and (min-width: 480px) and (max-width: 767px) {
  .blog-area4 {
    padding-bottom: 120px;
  }
}

@media only screen and (min-width: 320px) and (max-width: 479px) {
  .blog-area4 {
    padding-bottom: 120px;
  }
}

.blog-area4 .blog-content-wrap .blog-item .blog-img-box {
  position: relative;
  -webkit-border-radius: 4px 4px 0 0;
  -moz-border-radius: 4px 4px 0 0;
  border-radius: 4px 4px 0 0;
}

.blog-area4 .blog-content-wrap .blog-item .blog-img-box img {
  width: 100%;
  -webkit-border-radius: 4px 4px 0 0;
  -moz-border-radius: 4px 4px 0 0;
  border-radius: 4px 4px 0 0;
}

.blog-area4 .blog-content-wrap .blog-item .blog-img-box .blog__date {
  position: absolute;
  top: 20px;
  left: 20px;
  background-color: #fff;
  text-transform: capitalize;
  font-weight: 500;
  color: #233d63;
  display: inline-block;
  padding: 8px 12px;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
  z-index: 1;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -ms-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
}

.blog-area4 .blog-content-wrap .blog-item .blog-img-box:after {
  position: absolute;
  content: '';
  bottom: -1px;
  left: 30px;
  width: 0;
  height: 0;
  border-left: 20px solid transparent;
  border-right: 20px solid transparent;
  border-bottom: 20px solid #fff;
}

.blog-area4 .blog-content-wrap .blog-item .blog-content {
  border: 1px solid rgba(127, 136, 151, 0.2);
  border-top: 0;
  -webkit-border-radius: 0 0 4px 4px;
  -moz-border-radius: 0 0 4px 4px;
  border-radius: 0 0 4px 4px;
  padding: 30px 30px 35px 30px;
  margin-bottom: 60px;
}

.blog-area4 .blog-content-wrap .blog-item .blog-content .blog__title {
  font-size: 40px;
  line-height: 50px;
  color: #233d63;
  font-weight: 600;
}

@media (max-width: 480px) {
  .blog-area4 .blog-content-wrap .blog-item .blog-content .blog__title {
    font-size: 30px;
    line-height: 35px;
  }
}

.blog-area4 .blog-content-wrap .blog-item .blog-content .blog__list {
  margin-top: 10px;
  margin-bottom: 30px;
  padding-bottom: 30px;
  border-bottom: 1px solid rgba(127, 136, 151, 0.2);
}

.blog-area4 .blog-content-wrap .blog-item .blog-content .blog__list li {
  display: inline-block;
  margin-right: 10px;
}

.blog-area4 .blog-content-wrap .blog-item .blog-content .blog__list li:last-child {
  margin-right: 0;
}

.blog-area4 .blog-content-wrap .blog-item .blog-content .blog__list li .la {
  margin-right: 5px;
}

.blog-area4 .blog-content-wrap .blog-item .blog-content .blog__list li a {
  color: #7f8897;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -ms-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
}

.blog-area4 .blog-content-wrap .blog-item .blog-content .blog__list li a:hover {
  color: #51be78;
}

.blog-area4 .blog-content-wrap .blog-item .blog-content .blog__desc {
  line-height: 28px;
  margin-bottom: 15px;
}

.blog-area4 .blog-content-wrap .blog-item .blog-content .content-requirement .blog__title {
  font-size: 24px;
}

.blog-area4 .blog-content-wrap .blog-item .blog-content .content-requirement .content__list {
  margin-bottom: 20px;
}

.blog-area4 .blog-content-wrap .blog-item .blog-content .content-requirement .content__list li {
  position: relative;
  padding-left: 15px;
  margin-bottom: 10px;
}

.blog-area4 .blog-content-wrap .blog-item .blog-content .content-requirement .content__list li:last-child {
  margin-bottom: 0;
}

.blog-area4 .blog-content-wrap .blog-item .blog-content .content-requirement .content__list li:after {
  position: absolute;
  width: 6px;
  height: 6px;
  content: '';
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  background-color: #7f8897;
  top: 6px;
  left: 0;
}

.blog-content img {
  width: 100%;
}

.blog-area4 .blog-content-wrap .blog-item .blog-content .tags-item {
  margin-top: 35px;
  border-top: 1px solid rgba(127, 136, 151, 0.2);
  padding-top: 35px;
  display: -webkit-flex;
  display: -ms-flex;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
}

@media only screen and (min-width: 480px) and (max-width: 767px) {
  .blog-area4 .blog-content-wrap .blog-item .blog-content .tags-item {
    display: block;
  }
}

@media only screen and (min-width: 320px) and (max-width: 479px) {
  .blog-area4 .blog-content-wrap .blog-item .blog-content .tags-item {
    display: block;
  }
}

.blog-area4 .blog-content-wrap .blog-item .blog-content .tags-item ul {
  display: -webkit-flex;
  display: -ms-flex;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
}

@media (max-width: 425px) {
  .blog-area4 .blog-content-wrap .blog-item .blog-content .tags-item ul {
    display: block;
  }
}

.blog-area4 .blog-content-wrap .blog-item .blog-content .tags-item ul li {
  margin-right: 5px;
}

@media (max-width: 425px) {
  .blog-area4 .blog-content-wrap .blog-item .blog-content .tags-item ul li {
    display: inline-block;
  }
}

.blog-area4 .blog-content-wrap .blog-item .blog-content .tags-item ul li span {
  color: #233d63;
  font-weight: 600;
}

@media (max-width: 425px) {
  .blog-area4 .blog-content-wrap .blog-item .blog-content .tags-item ul.tag__list li {
    margin-bottom: 15px;
  }
}

.blog-area4 .blog-content-wrap .blog-item .blog-content .tags-item ul.tag__list li a {
  background-color: rgba(81, 190, 120, 0.1);
  color: #51be78;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
  padding: 5px 12px;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -ms-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
}

.blog-area4 .blog-content-wrap .blog-item .blog-content .tags-item ul.tag__list li a:hover {
  background-color: #51be78;
  color: #fff;
}

.blog-area4 .blog-content-wrap .blog-item .blog-content .tags-item ul.social__links {
  margin-left: auto;
}

@media only screen and (min-width: 480px) and (max-width: 767px) {
  .blog-area4 .blog-content-wrap .blog-item .blog-content .tags-item ul.social__links {
    margin-top: 20px;
  }
}

@media only screen and (min-width: 320px) and (max-width: 479px) {
  .blog-area4 .blog-content-wrap .blog-item .blog-content .tags-item ul.social__links {
    margin-top: 20px;
  }
}

.blog-area4 .blog-content-wrap .blog-item .blog-content .tags-item ul.social__links li a {
  width: 35px;
  height: 35px;
  line-height: 35px;
  text-align: center;
  background-color: rgba(81, 190, 120, 0.1);
  color: #51be78;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  display: block;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -ms-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
}

.blog-area4 .blog-content-wrap .blog-item .blog-content .tags-item ul.social__links li a:hover {
  background-color: #51be78;
  color: #fff;
}

.blog-area4 .blog-content-wrap .blog-item .instructor-wrap .instructor-wrap__title {
  font-size: 24px;
  font-weight: 600;
}

.blog-area4 .blog-content-wrap .blog-item .instructor-wrap .instructor-content {
  margin-top: 40px;
  margin-bottom: 40px;
}

.blog-area4 .blog-content-wrap .blog-item .instructor-wrap .instructor-content .instructor-img .instructor__avatar img {
  width: 150px;
  height: 150px;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  margin-right: 20px;
}

@media only screen and (min-width: 480px) and (max-width: 767px) {
  .blog-area4 .blog-content-wrap .blog-item .instructor-wrap .instructor-content .instructor-img .instructor__avatar img {
    margin-right: 0;
    margin-bottom: 20px;
  }
}

@media only screen and (min-width: 320px) and (max-width: 479px) {
  .blog-area4 .blog-content-wrap .blog-item .instructor-wrap .instructor-content .instructor-img .instructor__avatar img {
    margin-right: 0;
    margin-bottom: 20px;
  }
}

.blog-area4 .blog-content-wrap .blog-item .instructor-wrap .instructor-content .instructor-details .instructor-titles {
  margin-bottom: 20px;
}

.blog-area4 .blog-content-wrap .blog-item .instructor-wrap .instructor-content .instructor-details .instructor-titles .instructor__title {
  font-size: 22px;
  font-weight: 600;
}

.blog-area4 .blog-content-wrap .blog-item .instructor-wrap .instructor-content .instructor-details .instructor-desc .instructor__text {
  line-height: 28px;
  margin-bottom: 15px;
}

.blog-area4 .blog-content-wrap .blog-item .instructor-wrap .instructor-content .instructor-details .instructor-desc .instructor__links {
  color: #233d63;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -ms-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
}

.blog-area4 .blog-content-wrap .blog-item .instructor-wrap .instructor-content .instructor-details .instructor-desc .instructor__links:hover {
  color: #51be78;
}

@media only screen and (min-width: 480px) and (max-width: 767px) {
  .blog-area4 .blog-content-wrap .blog-item .instructor-wrap .instructor-content.d-flex {
    display: block !important;
  }
}

@media only screen and (min-width: 320px) and (max-width: 479px) {
  .blog-area4 .blog-content-wrap .blog-item .instructor-wrap .instructor-content.d-flex {
    display: block !important;
  }
}

.blog-area4 .blog-content-wrap .blog-item .comments-wrapper .contact-title {
  margin-bottom: 35px;
}

.blog-area4 .blog-content-wrap .blog-item .comments-wrapper .comments-list li .comment .comment-body .meta-data {
  display: -webkit-flex;
  display: -ms-flex;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
}

@media only screen and (min-width: 480px) and (max-width: 767px) {
  .blog-area4 .blog-content-wrap .blog-item .comments-wrapper .comments-list li .comment .comment-body .meta-data {
    display: block;
  }
}

@media only screen and (min-width: 320px) and (max-width: 479px) {
  .blog-area4 .blog-content-wrap .blog-item .comments-wrapper .comments-list li .comment .comment-body .meta-data {
    display: block;
  }
}

.blog-area4 .blog-content-wrap .blog-item .comments-wrapper .comments-list li .comment .comment-body .meta-data .comment__author {
  margin-bottom: 0;
}

.blog-area4 .blog-content-wrap .blog-item .comments-wrapper .comments-list li .comment .comment-body .meta-data .comment__date {
  margin-left: auto;
}
.blog__desc img {
  width: 100%;
}
.blog-content img{
  width: 100%;
}
</style>